
// Namespacing

window.site = (window.site || {});


// PressSlider - opened / close

site.PressSlider = (function PressSlider($) {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false,
    $carousel = null;

    /**
     * Initializes the class.
     * @public
     */
    var init = function() {

      // Abort if already initialized
      if (inited) {
        return false;
      }

      inited = true;

      // Initiate SidePanel
      initSlider();

      return true;

    };

    // ------------------------------------
    // EVENT HANDLERS
    // ------------------------------------

    var initSlider = function() {

      $carousel = $('.press-slider').flickity({
        'cellSelector': '.press-slide',
        'cellAlign': 'left',
        'contain': true,
        'wrapAround': true,
        'prevNextButtons': true,
        'pageDots': false,
        'imagesLoaded': true
      });

    };

    return {
      init: init
    };

}.bind(site, jQuery)());

